export let acuerdoLineasFormConstant = {
    id: {
      value: ""
    },
    naviera_id: {
      value: {
        id: "",
        name: ""
      }
    },
  naviera_salida: {
    value: {
      id: "",
      name: ""
    }
  },
    pol: {
      value: {
        id: "",
        name: ""
      }
    },
    pod: {
      value: {
        id: "",
        name: ""
      }
    },
    atmosphere_id: {
      value: {
        id: "",
        name: ""
      }
    },
    coldtreatment: {
      value: {
        id: "",
        name: ""
      }
    },
    container_id: {
      value: {
        id: "",
        name: ""
      }
    },
    products_category_id: {
      value: {
        id: "",
        name: ""
      }
    },
    from_date: {
      value: ""
    },
    to_date: {
      value: ""
    },
    transit_time: {
      value: ""
    },
    neta: {
      value: ""
    },
    public_value: {
      value: ""
    },
    contract: {
      value: ""
    },
    free_days_land: {
      value: ""
    },
    plug_days_land: {
      value: ""
    },
    genset: {
      value: false
    },
  get_out: {
    value: false
  },
    comment: {
      value: ""
    },
    country_id: {
      value: ""
    },
    id_by_country: {
      value: ""
    },
    tariff_contract_id: {
        value: {
            id: "",
            name: ""
        }
    },
    free_days_embark: {
      value: ""
    },
    plug_days_embark: {
      value: ""
    },
    type_contract: {
        value: {
            id: "",
            name: ""
        }
    },
    navieras_salida_list: []
};